// Copyright (c) 2016 Deere & Company

import BusyCounter, {getDefaultState as getBusyCounterDefaultState} from '../../../shared/state/busy-counter';
import EmissionsPartSearch, {getDefaultState as getEmissionsPartSearchDefaultState} from './report';
import t from 'tcomb';

const State = t.struct({
    busyCounter: BusyCounter,
    partNumberSearchCriteria: t.String,
    report: EmissionsPartSearch,
    showNoResultsFound: t.Boolean
}, 'State');

export const getDefaultState = () =>
    new State({
        busyCounter: getBusyCounterDefaultState(),
        partNumberSearchCriteria: '',
        report: getEmissionsPartSearchDefaultState(),
        showNoResultsFound: false
    });

export default State;



// WEBPACK FOOTER //
// ./src/reports/emissions-part-search/state/index.js